import React from "react";
import "./InputTable.css";
import PenaltySelector from "./PenaltyReasonSelector";

const ClipEndPenaltyInfo = (props) => {
  const { penaltyReason, setPenaltyReason } = props;

  const handleOptionChange = async (event) => {
    await setPenaltyReason(parseInt(event.target.value));
  };

  return (
    <PenaltySelector
      penalty={penaltyReason}
      handleOptionChange={handleOptionChange}
    />
  );
};

export default ClipEndPenaltyInfo;
